import CourseActions from '../actions/courseActions';
import QuizActions from '../actions/quizActions';
import axios from 'axios';
import Path from '../../config/path';

class CourseMiddleware {

    static coursesMiddleware(data) {
        // console.log(data)
        return dispatch => {
            let joinedCourses = new Promise((resolve, reject) => {
                axios.get(`${Path.UPDATE}${data.id}/myapi/alljoinedcourses/${new Date().getTime()}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "pc_access_token": `${data.pc_access_token}`,
                        "userId": `${data.id}`
                    }
                }).then((data) => resolve(data))
                    .catch((err) => reject(err))
            })

            let allCourses =
                new Promise((resolve, reject) => {
                    setTimeout(() => {
                        axios.get(`${Path.UPDATE}${data.id}/course/allcourses/${new Date().getTime()}`, {
                            headers: {
                                "Content-Type": "application/json",
                                "pc_access_token": `${data.pc_access_token}`,
                                "userId": `${data.id}`
                            }
                        })
                            .then((data) => resolve(data))
                            .catch((err) => reject(err))
                    }, 100)
                })

            Promise.all([joinedCourses, allCourses]).then((response) => {
                // console.log("promise response", response)
                let obj = {
                    joinedCourses: response[0].data.joinedCourse,
                    allCourses: response[1].data.data
                }
                dispatch(CourseActions.CoursesSuccess(obj))
            }).catch((err) => {
                // console.log(err)
                dispatch(CourseActions.CoursesFailed(err))
                })
        }
    }

    static joinCourseMiddleware(data) {
        return dispatch => {
            axios.post(`${Path.UPDATE}${data.id}/course/${data.courseId}/class/${data.classId}/join?userId=${data.id}&courseId=${data.courseId}&classId=${data.classId}`, {
                isRegister: true
            }).then((response) => {
                dispatch(CourseActions.JoinCourseSuccess(response.data.data))
            }).catch((err) => {
                dispatch(CourseActions.JoinCourseFailed(err))
                })
        }
    }

    static modulesMiddleware(data) {
        // console.log(data)
        return dispatch => {
                axios.get(`${Path.UPDATE}${data.userId}/course/${data.courseId}/all/${new Date().getTime()}?userId=${data.userId}&courseId=${data.courseId}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "pc_access_token": `${data.pc_access_token}`,
                        "userId": `${data.userId}`
                    }
                }).then((response) => {
                    // console.log(response.data.data)
                    dispatch(CourseActions.ModulesSuccess(response.data.data))
                    dispatch(QuizActions.ClearProctorKey())
                    dispatch(QuizActions.ClearDeleteAnswerSheet())
                }).catch((err) => {
                    dispatch(CourseActions.ModulesFailed(err))
                })
            // }
        }
    }

    static quizInfoMiddleware(data) {
        // console.log(data)
        return dispatch => {
            axios.get(`${Path.UPDATE}${data.userId}/course/${data.courseId}/quiz/${data.quizId}/${new Date().getTime()}?userId=${data.userId}&quizId=${data.quizId}&classId=${data.classId}`, {
                headers: {
                    "Content-Type": "application/json",
                    "pc_access_token": `${data.pc_access_token}`,
                    "userId": `${data.userId}`
                }
            }).then((response) => {
                // console.log(response.data.data)
                dispatch(CourseActions.QuizInfo(response.data.data))
            }).catch((err) => {
                // console.log(err)
            })
        }
    }
}
export default CourseMiddleware;


// WEBPACK FOOTER //
// ./src/store/middleware/courseMiddleware.js